import type { Validate } from 'react-hook-form'

export const uncheckedRule =
  (errorMessage: string): Validate<boolean, unknown> =>
  (value?: boolean) => {
    return value === true ? undefined : errorMessage
  }
